/**
 * Provides a UI for displaying and manipulating map service properties, including security.
 *
 * ## Events
 * Name | Arguments | Description
 * --- | --- | ---
 * zoom | The `MapServiceBase` associated with this view. | Fires when a user elects to zoom to the extents of the given service.
 * locate | The `MapServiceBase` associated with this view. | Fires when a user elects to pan to the given service.
 * service-remove | The `MapServiceBase` associated with this view. | Fires when the `MapService` model associated with the given service instance has been successfully removed from the data source.
 * @module app/views/map/ServicePanelView
 * @extends {MapDetailView}
 */
import MapDetailView from "app/views/map/MapDetailView";
import _ from "underscore";
import Field from "core/models/Field";
import FormView from "core/views/FormView";
import DetailView from "core/views/DetailView";
import MapService from "app/models/MapService";
import TabView from "core/views/TabView";
import Backbone from "backbone";
import GeographicSummarizer from "app/models/map/summarize/GeographicSummarizer";
import session from "app/Session";
import logger from "app/Logger";
import mapContext from "app/views/map/MapContext";
export default MapDetailView.extend({
  className: "service-detail-view",
  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {MapServiceBase} options.service The service which shall be associated with this view.
   * @param {MapContext} options.context The MapContext associated with this view.
   */
  initialize: function (options) {
    MapDetailView.prototype.initialize.apply(this, arguments);

    this.options = _.defaults({}, options, {
      service: null, //of type MapServiceBase
    });
    this.setTitle("Service Detail");
  },

  render: function () {
    var fields = [new Field(MapService.fields["name"])];
    var canUpdate = session.can(["update", "own"], {
      MapService: this.options.service.service.id,
    });

    var ServiceView;
    var service = this.options.service;

    if (canUpdate) {
      ServiceView = FormView;
    } else {
      ServiceView = DetailView;
    }

    var formView = (this._formView = new ServiceView({
      fields: fields,
      model: this.options.service.service,
    }));

    formView.render();

    var tabs = [
      {
        view: formView,
        buttons: [],
        title: "Attributes",
      },
    ];

    var summarizers = [];

    if (!service.service.get("external")) {
      summarizers.push(new GeographicSummarizer());
    }

    /*
		_.each(this.options.context.plugins, function (plugin) {
			if (plugin.handlesService(service)) {
				var view = plugin.viewForService(service);
				var summarizer = plugin.getSummarizer();

				if (view) {
					tabs.push({
						view: new Backbone.View({
							el: view[0]
						}),
						buttons: [],
						title: plugin.name
					});
				}

				if (summarizer) {
					summarizers.push(summarizer);
				}
			}
		}, this);
		*/

    _.each(
      summarizers,
      function (summarizer) {
        var summary = summarizer.summarizeService(service);
        var summaryView = new Backbone.View();

        summaryView.render();
        _.each(
          summary.summary_layers,
          function (layer, name) {
            var detailView = new DetailView({
              model: layer,
              fields: layer.summary_fields,
            });

            detailView.render();
            summaryView.$el.append("<h4>" + name + "</h4>");
            summaryView.$el.append(detailView.$el);
          },
          this
        );

        var detailView = new DetailView({
          model: summary,
          fields: summary.summary_fields,
        });

        detailView.render();
        summaryView.$el.append("<h4>" + "Service Summary" + "</h4>");
        summaryView.$el.append(detailView.$el);

        tabs.push({
          view: summaryView,
          buttons: [],
          title: summarizer.getName(),
        });
      },
      this
    );

    this.$el.uniqueId();
    var tabView = new TabView({
      tabs: tabs,
      prefix: this.$el.attr("id"),
    });

    this.listenTo(
      tabView,
      "enter",
      function (tab) {
        if (tab.title) {
          logger.operation("tab-clicked", { title: tab.title });
        }
      },
      this
    );

    tabView.render();

    this.$el.append(tabView.$el);

    //now add some icons
    this.refreshControls();
  },

  refreshControls: function () {
    var self = this;

    this.clearControls();
    this.addControl(
      this.createIconButton(
        mapContext
          .getOperation("save-service")
          .withModel(this.options.service)
          .wrap(function () {
            return self._formView.propagate();
          })
      )
    );
    this.addControl(
      this.createIconButton(
        mapContext
          .getOperation("edit-service-security")
          .withModel(this.options.service)
      )
    );
    this.addControl(
      this.createIconButton(
        mapContext
          .getOperation("delete-service")
          .withModel(this.options.service)
      )
    );
    this.addControl(
      this.createIconButton(
        mapContext.getOperation("pan-to-item").withModel(this.options.service)
      )
    );
    this.addControl(
      this.createIconButton(
        mapContext.getOperation("zoom-to-item").withModel(this.options.service)
      )
    );
    this.addControl(
      this.createIconButton(
        mapContext
          .getOperation("set-selectable")
          .withModel(this.options.service)
      )
    );
    this.addControl(
      this.createIconButton(
        mapContext
          .getOperation("set-unselectable")
          .withModel(this.options.service)
      )
    );
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/ServicePanelView.js
// module id = 947
// module chunks = 1